/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './template-prescription.reducer';

export const TemplatePrescription = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const templatePrescriptionList = useAppSelector(state => state.templatePrescription.entities);
  const loading = useAppSelector(state => state.templatePrescription.loading);
  const totalItems = useAppSelector(state => state.templatePrescription.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="template-prescription-heading" data-cy="TemplatePrescriptionHeading">
        <Translate contentKey="tinyMedicRestApp.templatePrescription.home.title">Template Prescriptions</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.templatePrescription.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/template-prescription/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.templatePrescription.home.createLabel">Create new Template Prescription</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.templatePrescription.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {templatePrescriptionList && templatePrescriptionList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('patientType')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.patientType">Patient Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('patientType')} />
                </th>
                <th className="hand" onClick={sort('templateName')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.templateName">Template Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('templateName')} />
                </th>
                <th className="hand" onClick={sort('forSymptom')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.forSymptom">For Symptom</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('forSymptom')} />
                </th>
                <th className="hand" onClick={sort('liver')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.liver">Liver</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('liver')} />
                </th>
                <th className="hand" onClick={sort('GFR')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.GFR">GFR</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('GFR')} />
                </th>
                <th className="hand" onClick={sort('weightMin')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.weightMin">Weight Min</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('weightMin')} />
                </th>
                <th className="hand" onClick={sort('weightMax')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.weightMax">Weight Max</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('weightMax')} />
                </th>
                <th className="hand" onClick={sort('assessment')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.assessment">Assessment</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('assessment')} />
                </th>
                <th className="hand" onClick={sort('diagnosisNotes')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.diagnosisNotes">Diagnosis Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('diagnosisNotes')} />
                </th>
                <th className="hand" onClick={sort('medicationPlan')}>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.medicationPlan">Medication Plan</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('medicationPlan')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.owner">Owner</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.hospital">Hospital</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.templatePrescription.speciality">Speciality</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {templatePrescriptionList.map((templatePrescription, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/template-prescription/${templatePrescription.id}`} color="link" size="sm">
                      {templatePrescription.id}
                    </Button>
                  </td>
                  <td>{templatePrescription.active ? 'true' : 'false'}</td>
                  <td>{templatePrescription.cursor}</td>
                  <td>{templatePrescription.timestampEntry}</td>
                  <td>{templatePrescription.lastUpdated}</td>
                  <td>{templatePrescription.microSec}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PatientType.${templatePrescription.patientType}`} />
                  </td>
                  <td>{templatePrescription.templateName}</td>
                  <td>{templatePrescription.forSymptom}</td>
                  <td>{templatePrescription.liver}</td>
                  <td>{templatePrescription.GFR}</td>
                  <td>{templatePrescription.weightMin}</td>
                  <td>{templatePrescription.weightMax}</td>
                  <td>{templatePrescription.assessment}</td>
                  <td>{templatePrescription.diagnosisNotes}</td>
                  <td>{templatePrescription.medicationPlan}</td>
                  <td>
                    {templatePrescription.owner ? (
                      <Link to={`/doctor/${templatePrescription.owner.id}`}>{templatePrescription.owner.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {templatePrescription.hospital ? (
                      <Link to={`/hospital/${templatePrescription.hospital.id}`}>{templatePrescription.hospital.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {templatePrescription.speciality ? (
                      <Link to={`/especialty/${templatePrescription.speciality.id}`}>{templatePrescription.speciality.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/template-prescription/${templatePrescription.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/template-prescription/${templatePrescription.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/template-prescription/${templatePrescription.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.templatePrescription.home.notFound">No Template Prescriptions found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={templatePrescriptionList && templatePrescriptionList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default TemplatePrescription;
